export const getUserID = () => {
	return window.lscache.get("rocketiumUserId");
};

export const getSessionID = () => {
	return window.lscache.get("sessionId");
};

export const nullCheck = field => {
	return (field === undefined || field === null || field === "");
};